import { Component } from '@angular/core';

/**
 * Generated class for the TopNavComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'top-nav',
  templateUrl: 'top-nav.html'
})
export class TopNavComponent {

  personsname: String;

  constructor() {
    this.personsname = '123';
  }

}



// WEBPACK FOOTER //
// ./src/components/top-nav/top-nav.ts